import React from 'react';
import '../Loader.css';
const Loader = ({ size = 'medium', fullScreen = false, inline = false }) => {
  const sizeClasses = {
    small: 'loader-small',
    medium: 'loader-medium',
    large: 'loader-large'
  };

  if (fullScreen) {
    return (
      <div className="loader-fullscreen">
        <div className={`loader ${sizeClasses[size]}`}>
          <div className="spinner"></div>
        </div>
      </div>
    );
  }

  if (inline) {
    return (
      <div className={`loader ${sizeClasses[size]}`}>
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="loader-container">
      <div className={`loader ${sizeClasses[size]}`}>
        <div className="spinner"></div>
      </div>
    </div>
  );
};

export default Loader;